import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "../App.css";
import gdswlogo from "../images/gdswlogo.png";
import { useToast } from "../context/ToastContext";

const navData = [
  {
    id: 0,
    text: "Category",
    link: "/category",
    color: "#320473",
    fontSize: "16px",
    fontWeight: "550",
  },
  {
    id: 0,
    text: "Product",
    link: "/dashboard",
    color: "#320473",
    fontSize: "16px",
    fontWeight: "550",
  },
  {
    id: 1,
    text: "Coupon",
    link: "/coupon",
    color: "#320473",
    fontSize: "16px",
    fontWeight: "550",
  },
  {
    id: 2,
    text: "Orders",
    link: "/order",
    color: "#320473",
    fontSize: "16px",
    fontWeight: "550",
  },
  {
    id: 3,
    text: "Customers",
    link: "/client",
    color: "#320473",
    fontSize: "16px",
    fontWeight: "550",
  },
  {
    id: 4,
    text: "Logout",
    link: "/",
    color: "#320473",
    fontSize: "16px",
    fontWeight: "550",
  },
];

const Sidenav1 = () => {
  const [open, setOpen] = useState(true);
  const { showToast } = useToast();
  const handleLogout = () => {
    localStorage.removeItem("userData");
    window.location.assign("/");
    showToast("Logged out successfully 🎉", "success");

  };

  return (
    <div className={open ? "sidenav" : "sidenavClosed"}>
      <div className="row ul_list">
        <li
          style={{
            width: "95%",
            borderBottom: "1px solid grey",
            display: open ? " flex" : "none",
          }}>
          <NavLink
            to="/dashboard"
            end
            className="link_tag img"
          >
            <img
              className="m-auto"
              width="60"
              height="60"
              src={gdswlogo}
              alt="logo"
            />
            <h6>GDSWELLNESS</h6>
          </NavLink>

        </li>

        {navData.map(item => {
          return (
            <li key={item.id}>
              {item.text === "Logout" ? (
                <NavLink
                  to="/"
                  className="sideitem logout"
                  onClick={handleLogout}
                >
                  <span>{item.text}</span>
                </NavLink>

              ) : (
                <NavLink
                  to={item.link}
                  className={({ isActive }) =>
                    isActive ? "sideitem active" : "sideitem"
                  }
                >
                  <span
                    className={open ? " " : "active"}
                    style={{
                      color: item.color,
                      fontSize: item.fontSize,
                      fontWeight: item.fontWeight,
                    }}>
                    {item.text}
                  </span>
                </NavLink>
              )}
            </li>
          );
        })}
      </div>
    </div>
  );
};

export default Sidenav1;
